export const isPartnerUser = (user) => {
  return Boolean(
    user?.accountType === 'partner' ||
    user?.partnerId ||
    user?.partner_id ||
    user?.userType === 'PARTNER' ||
    user?.user_type === 'PARTNER' ||
    user?.userRole === 'PARTNER' ||
    user?.user_role === 'PARTNER'
  );
};

export const getPostLoginRoute = (user) => {
  if (isPartnerUser(user)) {
    return '/partner/dashboard';
  }

  if (user?.status === 2) {
    return '/merchant/dashboard';
  }

  if (user?.status === 1) {
    return '/merchant/setup';
  }

  return '/dan-auth';
};
